import NextSection from "@components/About/NextSection";
import cx from "classnames";
import styles from "./OtherRooms.module.scss";
import Item from "./Item";
import Swiper from "@components/Swiper";
// import { useMemo } from "react";
import useSwiper from "@hooks/useSwiper";
import { useTranslationContext } from "@providers/TranslationProvider";
import getter from "@services/RoomService/getter";
import _ from "lodash";
export default function OtherRooms({ data }: any) {
  useSwiper(".swiper-other-rooms", {
    spaceBetween: 32,
    slidesPerView: "auto",
  });
  const { i18n } = useTranslationContext();
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <NextSection className={cx(styles.titleSectionWrapper)} type="dark">
        <div className={cx(styles.titleSection)}>
          {i18n.t("Rooms.otherRooms")}
        </div>
      </NextSection>
      <Swiper className={cx("swiper-other-rooms", styles.swiper)}>
        {_.map(data, (item, index) => {
          return (
            <Item
              className="swiper-slide"
              data={{
                slug: getter.slug(item),
                title: getter.name(item),
                image: getter.image(_.get(item, "attributes.thumbnail")),
                // image: {
                //   src: getter.thumbnail(item),
                //   alt: getter.name(item),
                // },
              }}
              key={`slide_${getter.name(item)}_${index}`}
            />
          );
        })}
      </Swiper>
    </div>
  );
}
